export function isFunction(
    value: string | ((...args: any[]) => string),
): value is (...args: any[]) => string {
    return typeof value === "function";
}
